import { render } from "./trashСanIcon.vue?vue&type=template&id=4bd19888"
import script from "./trashСanIcon.vue?vue&type=script&lang=js"
export * from "./trashСanIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__